(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bhs-dealer-application-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function valueForField(field) {
      if (field.type === 'checkbox') {
        return field.checked ? (field.value || 'Accepted') : '';
      }
      return (field.value || '').trim();
    }

    function summaryLabel(field) {
      if (field.dataset.summary) return field.dataset.summary;
      var label = field.id ? document.querySelector('label[for="' + field.id + '"]') : null;
      return label ? label.textContent.replace('*', '').trim() : field.name;
    }

    function initDealerApplication(root) {
      if (root.dataset.dealerApplicationReady === 'true') return;
      root.dataset.dealerApplicationReady = 'true';
      root.classList.add('is-js');

      var form = root.querySelector('form');
      var steps = Array.prototype.slice.call(root.querySelectorAll('[data-app-step]'));
      var navItems = Array.prototype.slice.call(root.querySelectorAll('[data-step-nav]'));
      var currentStep = 1;

      function setStep(stepNumber) {
        currentStep = stepNumber;
        steps.forEach(function (step) {
          var isActive = Number(step.dataset.appStep) === stepNumber;
          step.classList.toggle('is-active', isActive);
        });
        navItems.forEach(function (item) {
          var isActive = Number(item.dataset.stepNav) === stepNumber;
          item.classList.toggle('is-active', isActive);
        });
        var active = root.querySelector('[data-app-step="' + stepNumber + '"]');
        if (active) active.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }

      function fieldsInStep(stepNumber) {
        var step = root.querySelector('[data-app-step="' + stepNumber + '"]');
        if (!step) return [];
        return Array.prototype.slice.call(step.querySelectorAll('input, select, textarea'));
      }

      function setStepError(stepNumber, message) {
        var step = root.querySelector('[data-app-step="' + stepNumber + '"]');
        var error = step ? step.querySelector('[data-step-error]') : null;
        if (error) error.textContent = message || '';
      }

      function validateStep(stepNumber) {
        var fields = fieldsInStep(stepNumber);
        var firstInvalid = null;
        var message = '';

        fields.forEach(function (field) {
          field.classList.remove('is-invalid');
          field.removeAttribute('aria-invalid');

          var value = valueForField(field);
          var invalid = false;

          if (field.hasAttribute('data-required') && !value) {
            invalid = true;
            message = 'Please complete all required fields before continuing.';
          }

          if (!invalid && field.hasAttribute('data-email') && value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
            invalid = true;
            message = 'Please enter a valid email address.';
          }

          if (invalid) {
            field.classList.add('is-invalid');
            field.setAttribute('aria-invalid', 'true');
            if (!firstInvalid) firstInvalid = field;
          }
        });

        setStepError(stepNumber, message);
        if (firstInvalid) {
          firstInvalid.focus();
          return false;
        }
        return true;
      }

      function buildSummary() {
        var rows = [];
        var fields = Array.prototype.slice.call(root.querySelectorAll('input, select, textarea'));
        fields.forEach(function (field) {
          if (!field.name || field.type === 'hidden' || field.type === 'submit' || field.type === 'button') return;
          var value = valueForField(field);
          if (!value) return;
          rows.push(summaryLabel(field) + ': ' + value);
        });

        var business = root.querySelector('[name="contact[business_name]"]');
        var first = root.querySelector('[name="contact[first_name]"]');
        var last = root.querySelector('[name="contact[last_name]"]');
        var applicantName = root.querySelector('[data-applicant-name]');
        var body = root.querySelector('[data-application-summary]');

        var fullName = [first && first.value, last && last.value].filter(Boolean).join(' ').trim();
        if (applicantName) {
          applicantName.value = fullName && business && business.value ? fullName + ' - ' + business.value : fullName || (business ? business.value : '');
        }
        if (body) {
          body.value = 'Dealer Application\n\n' + rows.join('\n');
        }
      }

      root.querySelectorAll('[data-next-step]').forEach(function (button) {
        button.addEventListener('click', function () {
          var next = Number(button.dataset.nextStep);
          if (!validateStep(currentStep)) return;
          setStep(next);
        });
      });

      root.querySelectorAll('[data-prev-step]').forEach(function (button) {
        button.addEventListener('click', function () {
          setStep(Number(button.dataset.prevStep));
        });
      });

      if (form) {
        form.addEventListener('submit', function (event) {
          for (var index = 1; index <= steps.length; index += 1) {
            if (!validateStep(index)) {
              event.preventDefault();
              setStep(index);
              return;
            }
          }
          buildSummary();
        });
      }
    }

    document.querySelectorAll('[data-dealer-application]').forEach(initDealerApplication);

    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('[data-dealer-application]');
      if (section) initDealerApplication(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
